/**
 * Rainbow Mulch — Saved Project Summary (P-002, Sprint 12)
 *
 * Reads ?id=<token> from the URL, fetches it from the backend, and renders
 * one of three honest states. All customer-facing reasons for failure come
 * from the SERVER response, never a hardcoded client guess — the same D-045
 * discipline pb-builder.js already follows for save/specialist/checkout.
 *
 * Deliberately does NOT rehydrate the interactive 5-step builder. This is a
 * summary + current price, matching 07-checkout.md §4's actual requirement
 * ("produce a shareable URL that reopens the project") without taking on a
 * second, much larger interactive-state-restoration feature in the same pass.
 */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }

  function showState(name) {
    ['loading', 'not-found', 'error', 'found'].forEach(function (s) {
      var el = document.querySelector('[data-pb-project-state="' + s + '"]');
      if (el) el.hidden = s !== name;
    });
  }

  function fmtMoney(n) {
    return typeof n === 'number' ? '$' + n.toFixed(2) : '—';
  }

  function fmtDate(iso) {
    try {
      return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) {
      return '';
    }
  }

  function renderFound(data) {
    var cfg = window.PBConfig;
    var project = data.project || {};
    var current = data.current || {};

    $('[data-pb-project-saved-at]').textContent = data.createdAt
      ? 'Saved ' + fmtDate(data.createdAt) + '.'
      : '';

    $('[data-pb-project-out="dimensions"]').textContent = current.dimensionsLabel || '—';
    $('[data-pb-project-out="packaging"]').textContent = current.packagingLabel || project.packaging || '—';
    $('[data-pb-project-out="colour"]').textContent = current.colorLabel || '—';

    var priceBlock = $('[data-pb-project-price-current]');
    var priceUnavailable = $('[data-pb-project-price-unavailable]');

    if (current.error) {
      if (priceBlock) priceBlock.hidden = true;
      if (priceUnavailable) priceUnavailable.hidden = false;
    } else {
      if (priceBlock) priceBlock.hidden = false;
      if (priceUnavailable) priceUnavailable.hidden = true;
      $('[data-pb-project-out="currentTotal"]').textContent =
        typeof current.total === 'number' ? fmtMoney(current.total) + ' + tax, calculated at checkout' : 'Calculated at checkout';
      var note = $('[data-pb-project-price-note]');
      if (note) note.textContent = 'Recalculated just now — this is the current price, not what it was when saved.';
    }

    var snapshot = data.pricedSnapshot;
    var snapshotEl = $('[data-pb-project-snapshot]');
    if (snapshotEl && snapshot && typeof snapshot.total === 'number') {
      var changed = current.total !== undefined && current.total !== null && Math.abs(current.total - snapshot.total) > 0.005;
      snapshotEl.textContent = changed
        ? 'When you saved this project, the price was ' + fmtMoney(snapshot.total) + '. Prices can change — the current price above is the one that applies now.'
        : 'The price is the same as when you saved this project.';
    }
  }

  function load() {
    var cfg = window.PBConfig;
    var token = new URLSearchParams(window.location.search).get('id');

    if (!token) {
      showState('not-found');
      return;
    }

    showState('loading');

    fetch(cfg.backend.getProjectEndpoint + '?id=' + encodeURIComponent(token), {
      method: 'GET',
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { ok: res.ok, data: data };
      });
    }).catch(function () {
      return { ok: false, data: {} };
    }).then(function (r) {
      var data = r.data || {};

      if (r.ok && data.found === true) {
        renderFound(data);
        showState('found');
        return;
      }

      if (r.ok && data.found === false) {
        showState('not-found');
        return;
      }

      var detailEl = $('[data-pb-project-error-detail]');
      if (detailEl && data.detail) detailEl.textContent = data.detail;
      showState('error');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    load();
    var retry = $('[data-pb-project-retry]');
    if (retry) retry.addEventListener('click', load);
  });
})();
